import { render, staticRenderFns } from "./ComingUp.vue?vue&type=template&id=019b87d6"
import script from "./ComingUp.vue?vue&type=script&lang=js"
export * from "./ComingUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports